import { createApiClient, type ApiClient } from '@mrrmlab/api-client';
import type { AuthClient } from '@mrrmlab/auth';

/**
 * Build the shared ApiClient. When auth is disabled (dev mode without
 * Keycloak), getToken returns null — the backend's dev-user passthrough
 * takes over and requests still succeed.
 */
export function createApi(baseUrl: string, auth: AuthClient | null): ApiClient {
  return createApiClient({
    baseUrl,
    getToken: auth ? () => auth.getAccessToken() : undefined,
  });
}
